import { Injectable } from '@angular/core';
import { FrontendLanguage } from '../../utils/languageUtils';
import { LanguageService } from './language.service';
import { TranslateService } from '@ngx-translate/core';
import { Language, RequestLanguage } from '../../api';

export const API_LANG_MAPPINGS: { [key in FrontendLanguage]?: Language } = {
  de: 'DE',
  fr: 'FR',
  it: 'IT',
};

export const API_REQUEST_LANG_MAPPINGS: {
  [key in FrontendLanguage]?: RequestLanguage;
} = {
  de: 'DE',
  fr: 'FR',
  it: 'IT',
  en: 'EN',
};

@Injectable({
  providedIn: 'root',
})
export class ApiLanguageService {
  constructor(private translateService: TranslateService) {}

  public getCurrentRequestLanguageForApi(): RequestLanguage {
    const language = LanguageService.getFrontendLanguage(this.translateService.currentLang);
    return API_REQUEST_LANG_MAPPINGS[language] ?? RequestLanguage.De;
  }

  public getCurrentLanguageForApiOrUndefined(): Language | undefined {
    const language = LanguageService.getFrontendLanguage(this.translateService.currentLang);
    return API_LANG_MAPPINGS[language];
  }
}
